export enum ProfileEditFormKeys {
    Name = 'profile-name',
    Surname = 'profile-surname',
    Patronymic = 'profile-patronymic',
    JobTitle = 'profile-job-title',
    Department = 'profile-department',
    Phone = 'profile-phone',
    AgreementAdvert = 'profile-agreement-advert',
}

export enum ProfilePhotoEditFormKeys {
    Photo = 'profile-photo',
}
